import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Linkedin } from "lucide-react";
import { BRAND, FOOTER } from "../data/mock";
import { HexPattern } from "./reactbits/Anim";

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const Footer = () => (
  <footer className="relative overflow-hidden bg-[#1F1B13]" data-testid="footer">
    <HexPattern opacity={0.05} />
    <div className="relative mx-auto max-w-7xl px-6 py-16 lg:px-10">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <img src="/assets/logo-white.png" alt="MedHive" className="h-10 w-auto" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/55">
            Medhive is a Delaware incorporated medical devices technology, AI and SaaS company. Use of this site and
            platform is subject to our{" "}
            <Link to="/terms" className="text-[#F0A322] underline-offset-2 hover:underline">
              Terms of Use
            </Link>{" "}
            and{" "}
            <Link to="/privacy-policy" className="text-[#F0A322] underline-offset-2 hover:underline">
              Privacy Policy
            </Link>
            . Medhive does not provide medical advice, diagnosis, or treatment.
          </p>
        </div>

        <div className="md:justify-self-center">
          <h4 className="text-sm font-semibold uppercase tracking-[0.18em] text-white">Quick Links</h4>
          <ul className="mt-5 space-y-3">
            {FOOTER.quickLinks.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-white/60 transition-colors duration-200 hover:text-[#F0A322]">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:justify-self-end">
          <h4 className="text-sm font-semibold uppercase tracking-[0.18em] text-white">Reach Us</h4>
          <ul className="mt-5 space-y-3">
            <li>
              <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2.5 text-sm text-white/60 transition-colors hover:text-[#F0A322]">
                <Mail className="h-4 w-4 text-[#F0A322]" /> {BRAND.email}
              </a>
            </li>
            <li className="flex items-center gap-2.5 text-sm text-white/60">
              <MapPin className="h-4 w-4 text-[#F0A322]" /> {BRAND.location}
            </li>
            <li className="flex items-center gap-3 pt-1">
              <a
                href={BRAND.linkedin}
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/65 transition-colors duration-200 hover:border-[#F0A322]/60 hover:text-[#F0A322]"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                href={BRAND.x}
                target="_blank"
                rel="noreferrer"
                aria-label="X"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/65 transition-colors duration-200 hover:border-[#F0A322]/60 hover:text-[#F0A322]"
              >
                <XIcon className="h-3.5 w-3.5" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-6">
        <p className="text-xs text-white/45">{FOOTER.copyright}</p>
      </div>
    </div>
  </footer>
);

export default Footer;
